import React, { useEffect, useState } from "react";
import "./App.css";
import City from "./Component/City";
import Weather from "./Component/Weather";
// import { BrowserRouter, Route, Switch } from "react-router-dom";

function App() {
  const [search, setSearch] = useState("");
  const [cityname, setCityname] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [icon, setIcon] = useState(null);
  const [latlng, setLatlng] = useState({lat: 0,lng: 0, });
   

  useEffect(() => 
  {
    if ("geolocation" in navigator) 
    {
      navigator.geolocation.getCurrentPosition(function (position) {
        setLatlng({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
        
      });
          console.log(latlng);
      
        getmydata(search);
        setLoading(false);
        setCityname("Current");
       } 
       else {
      alert("Geolocation not available, search city");
    }
  }, [search,loading]);

  const getmydata = (mysearch) => {
    setSearch(mysearch);
    setLoading(true);

    const fetchApi = async () => {
      const API_KEY = "46494a187ed5ccd6d657456b0cd50092";

      const exclude = "minutely,alerts";
      const latlonuri = `https://api.opencagedata.com/geocode/v1/json?q=${mysearch}&key=bb78156b96424906af06e2ecd6f63111`;
      fetch(latlonuri)
        .then((res) => res.json())
        .then((latlondata) => {
          if (search.length === 0) {
            const uri = `https://api.openweathermap.org/data/2.5/onecall?units=metric&lat=${latlng.lat}&lon=${latlng.lng}&exclude=${exclude}&appid=${API_KEY}`;
            fetch(uri)
              .then((res) => res.json())
              .then((data) => {
                setData(data);
                //  console.log(data);
                // const { daily, hourly, current } = data;
                setIcon(data?.current?.weather[0].icon);
              });
          } else if (latlondata?.results && latlondata.results.length > 0) {
            const {
              lat,
              lng,
              name = "Invalid City Name!",
            } = latlondata?.results[0].geometry;
            setCityname(latlondata?.results[0]?.formatted);

            // console.log(setCityname)
            // console.log(lat,lng);
            const uri = `https://api.openweathermap.org/data/2.5/onecall?units=metric&lat=${
              search ? lat : latlng.lat
            }&lon=${
              search ? lng : latlng.lng
            }&exclude=${exclude}&appid=${API_KEY}`;

            fetch(uri)
              .then((res) => res.json())
              .then((data) => {
                setData(data);
                //  console.log(data);
                // const { daily, hourly, current } = data;
                setIcon(data?.current?.weather[0].icon);
              });

            setLoading(false);
            // console.log(data?.daily);
          } else {
            setData(404);
            setLoading(false);
            // alert("");
          }
        })
        .catch((err) => alert("invalid input!"));
    };
    fetchApi();
  };
  return (
    <div className="App">
      <City setSearch={getmydata} />
      <Weather
        search={search}
        icon={icon}
        data={data}
        loading={loading}
        cityname={cityname}
      />
    </div>
  );
}

export default App;
